<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-header bg-transparent text-center border-0">
          <h1>เข้าสู่ระบบ</h1>
        </div>
        <div class="card-body">
          <form role="form" v-on:submit="login">
            <base-input
              name="email"
              class="input-group-alternative mb-3"
              placeholder="Username"
              addon-left-icon="ni ni-single-02"
              v-model="email"
              :disabled="processing"
            ></base-input>

            <base-input
              name="password"
              class="input-group-alternative"
              placeholder="Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="password"
              :disabled="processing"
            ></base-input>

            <p class="text-sm text-red">{{ msg }}</p>
            <div class="text-center">
              <input
                type="submit"
                class="mb-4 btn btn-success"
                value="เข้าสู่ระบบ"
                :disabled="processing"
              />
            </div>
          </form>
        </div>
      </div>
      <Modal :show="showModal">
        <div class="col text-center">
          <h2>
            กรุณาใส่รหัสยืนยัน
          </h2>
          <base-input
            name="otp"
            class="input-alternative"
            placeholder="รหัสยืนยัน"
            type="text"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="otp"
            :disabled="processing"
          ></base-input>
          <p class="text-sm text-red">{{ msgOTP }}</p>
          <button
            type="button"
            class="close mt--5"
            data-dismiss="modal"
            aria-label="Close"
            @click="showModal = false"
          ></button>
          <div class="row justify-content-around mt-4">
            <base-button
              type="info"
              size="md"
              :disabled="processing"
              @click="loginOTP"
              >ยืนยัน</base-button
            >
            <base-button type="warning" size="md" @click="showModal = false"
              >ปิด</base-button
            >
          </div>
        </div></Modal
      >
    </div>
  </div>
</template>
<script>
import Modal from "../components/Modal";
import router from "../router";
import axios from "axios";

export default {
  name: "login",
  components: {
    Modal,
  },
  data() {
    return {
      otp: "",
      showModal: false,
      email: "",
      password: "",
      msg: "",
      msgOTP: "",
      processing: false,
    };
  },
  methods: {
    login: async function(e) {
      e.preventDefault();
      this.processing = true;
      this.msg = "";
      const url = "https://api.sd5525.com/api/login";
      try {
        await axios
          .post(url, { email: this.email, password: this.password })
          .then((res) => {
            this.processing = false;
            if (res.data.success) {
              if (res.data.success == true) {
                this.otp = "";
                this.msgOTP = "";
                this.showModal = true;
              } else {
                localStorage.token = res.data.success.token;
                localStorage.level = res.data.level;
                localStorage.name = res.data.name;
                router.push("/customerWsu");
              }
            } else {
              this.processing = false;
              this.msg = "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง";
            }
          });
      } catch (err) {
        this.processing = false;
        this.msg = "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง";
      }
    },
    loginOTP: async function(e) {
      e.preventDefault();
      this.processing = true;
      this.msgOTP = "";
      const url = "https://api.sd5525.com/api/loginOTP";
      try {
        await axios
          .post(url, {
            email: this.email,
            password: this.password,
            totp: this.otp,
          })
          .then((res) => {
            this.processing = false;
            if (res.data.success) {
              localStorage.token = res.data.success.token;
              localStorage.level = res.data.level;
              localStorage.name = res.data.name;
              router.push("/dashboard");
            } else {
              this.processing = false;
              this.msgOTP = "รหัสยืนยันไม่ถูกต้องหรือไม่ได้ทำรายการนานเกินไป";
            }
          });
      } catch (err) {
        this.processing = false;
        this.msgOTP = "รหัสยืนยันไม่ถูกต้องหรือไม่ได้ทำรายการนานเกินไป";
      }
    },
  },
  created: function() {
    if (localStorage.token) {
      this.lvl = localStorage.level;
      if (this.lvl === "999" || this.lvl === "0") {
        let routeData = this.$router.resolve({
          path: "/dashboard",
        });
        location.replace(routeData.href);
      } else {
        let routeData = this.$router.resolve({
          path: "/customerWsu",
        });
        location.replace(routeData.href);
      }
    }
  },
};
</script>
<style>
/* html {
  height: 100%;
  width: 100%;
} */
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
}
</style>
